export const cashPoolKeys = {
  all: ['cash-pools'] as const,
  lists: () => [...cashPoolKeys.all, 'list'] as const,
  list: (filters: string) => [...cashPoolKeys.lists(), { filters }] as const,
};
